import styled from "styled-components";

import { DropDownButton } from "./DropdownButton";

export const StyledDropDownButton = styled(DropDownButton)`
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  height: auto;
  width: auto !important;
  position: relative;
  flex: 0 0 auto !important;
  white-space: nowrap;
  font-weight: 600;
  border: none !important;
  color: ${({ theme }) => theme.colors.redesign.db100};
  background: ${({ theme }) => theme.colors.white};

  #DropdownButton {
    display: flex;
    align-items: center;
    border-radius: 8px;
    padding: 12px 16px;
    border: 1px solid ${({ theme }) => theme.colors.redesign.db20};
    background: transparent;
    transition: 0.2s;
    font: ${props => props.theme.font.link3};
    color: inherit;
    cursor: pointer;

    &:hover {
      color: ${({ theme }) => theme.colors.redesign.b100};
      background: ${props => props.theme.colors.redesign.b10};

      svg path {
        fill: ${({ theme }) => theme.colors.redesign.b100};
      }
    }

    svg path {
      fill: ${({ theme }) => theme.colors.redesign.db100};
      transition: 0.2s;
    }
  }
`;

export const ButtonText = styled.span`
  white-space: nowrap;
  font-weight: 500;
  font-size: 14px;
  color: inherit;
`;

export const StyledTreatmentDropDownButton = styled(DropDownButton)<{ $isOpen: boolean }>`
  width: 100%;

  #DropdownButton {
    justify-content: space-between;
    padding: 12px;
    border-radius: 8px;
    background: transparent;
    font-weight: 600;
    font-size: 14px;
    color: ${props => props.theme.colors.redesign.db100};
    width: 100%;
  }
`;

export const OptionItem = styled.div`
  display: flex;
  align-items: center;

  > svg {
    margin-right: ${props => props.theme.spacing.S_10};
    min-width: 25px;
  }
`;
